import { render, staticRenderFns } from "./tagEditDialog.vue?vue&type=template&id=1fc8513f&scoped=true&"
import script from "./tagEditDialog.vue?vue&type=script&lang=js&"
export * from "./tagEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./tagEditDialog.vue?vue&type=style&index=0&id=1fc8513f&prod&lang=scss&scoped=true&"
import style1 from "./tagEditDialog.vue?vue&type=style&index=1&id=1fc8513f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc8513f",
  null
  
)

export default component.exports